export const ProdutoStatusEnum = {
  Disponivel: 'Disponivel',
  Reservada: 'Reservada',
  Indisponivel: 'Indisponivel',
  Vendida: 'Vendida',
} as const
export type TProdutoStatusEnum = keyof typeof ProdutoStatusEnum

export const ProdutoTipoLegendaStatusEnum = {
  Disponivel: 'Disponivel',
  ReservadoPeloVendedor: 'ReservadoPeloVendedor',
  ReservadoPorProposta: 'ReservadoPorProposta',
  Indisponivel: 'Indisponivel',
}
export type TProdutoTipoLegendaStatusEnum = keyof typeof ProdutoTipoLegendaStatusEnum

export type TProduto = {
  idExterno: number
  id: string
  descricao: string
  valor: number
  status: TProdutoStatusEnum
  altaProcura?: boolean
  tipoLegendaStatus: TProdutoTipoLegendaStatusEnum
  detalhamentoStatus?: string
  andar?: number | null
}

export const TipoProdutoEnum = {
  Unidade: 'Unidade',
  Acessorio: 'Acessorio',
  VagaPadrao: 'VagaPadrao',
  Lote: 'Lote',
  Planta: 'Planta',
} as const
export type TTipoProdutoEnum = keyof typeof TipoProdutoEnum

export type TTipoProdutoChileEnum = Exclude<TTipoProdutoEnum, 'VagaPadrao' | 'Lote'>
export type TTipoProdutoBrasilEnum = Exclude<TTipoProdutoEnum, 'Planta'>

export type TTipoProdutoVerticalEnum = Exclude<TTipoProdutoEnum, 'Lote'>
export type TTipoProdutoVerticalBrasilEnum = Exclude<TTipoProdutoBrasilEnum, 'Lote' | 'Planta'>

export type TTipoProdutoPrecificadoBrasilEnum = Exclude<TTipoProdutoEnum, 'VagaPadrao' | 'Planta'>
